import React, { FC } from 'react';
import WallEvents from '../../../../../../../interfaces/WallEvents';
import { IconButton } from '@material-ui/core';
import { ItemType } from '../../../../../../../interfaces/api/ActivityWall';
import { createUseStyles } from '../../../../../../../theming';

const useStyles = createUseStyles({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
});

interface Props {
  onChange: (typeFilter?: ItemType) => void;
  value?: ItemType;
}

const EventTypePicker: FC<Props> = ({ onChange, value }) => {
  const classes = useStyles();
  const itemTypes = Object.keys(WallEvents) as ItemType[];

  return (
    <div className={classes.root}>
      {itemTypes.map((type) => {
        const event = WallEvents[type];
        const Icon = event.icon;

        return (
          <IconButton
            key={type}
            color={type === value ? 'secondary' : 'default'}
            onClick={() => onChange(type === value ? undefined : type)}
            title={event.title}
          >
            <Icon size={18} />
          </IconButton>
        );
      })}
    </div>
  );
};

export default EventTypePicker;
